import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f70c72a0&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f70c72a0&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=f70c72a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70c72a0",
  null
  
)

export default component.exports